import { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { getPreviousRegistrationPath } from '@/features/auth/navigation/registration.navigation'

export function RegistrationBackGuard() {
  const location = useLocation()
  const navigate = useNavigate()
  const currentPathRef = useRef(location.pathname)

  useEffect(() => {
    currentPathRef.current = location.pathname
  }, [location.pathname])

  useEffect(() => {
    function handleBrowserHistoryNavigation() {
      const sourcePath = currentPathRef.current
      const previousPath = getPreviousRegistrationPath(sourcePath)

      if (previousPath) navigate(previousPath, { replace: true })
    }

    window.addEventListener('popstate', handleBrowserHistoryNavigation)
    return () => window.removeEventListener('popstate', handleBrowserHistoryNavigation)
  }, [navigate])

  return null
}
